import React from "react";

import dayjs from "dayjs";

import { formatDate } from "../../../../../../../utils/DateHelpers";
import NewDatePicker from "../../../../../../shared/forms/DatePicker";
import NewFormRow from "../../../../../../shared/forms/NewFormRow";
import useCalulatorStore from "../../../../CalculatorPage/store";

const DatePicker = ({ value, onChange, label = "Datum" }) => {
    const [additions] = useCalulatorStore((state) => [state.additions]);

    const onDateChanged = (date) => {
        onChange(formatDate(date));
    };

    /**
     * Checks if the given date is a weekday and also not a feast day.
     * @param {*} date
     */
    const isAvailable = (date) => {
        const day = dayjs(date);
        const blockedSince = dayjs(additions.min_wish_date).subtract(1, "day");
        const blockedTil = dayjs(additions.max_wish_date).subtract(1, "day");

        return (
            day.weekday() !== 5 &&
            day.weekday() !== 6 &&
            blockedSince.isBefore(day) &&
            blockedTil.isAfter(day) &&
            !additions.feast_days.includes(day.format("YYYY-MM-DD"))
        );
    };

    if (additions) {
        return (
            <NewFormRow>
                <NewFormRow.Label>{label}</NewFormRow.Label>
                <NewFormRow.Value>
                    <NewDatePicker
                        value={value !== "" ? new Date(value) : value}
                        onChange={onDateChanged}
                        filterDate={isAvailable}
                        className="is-full-width"
                    />
                </NewFormRow.Value>
            </NewFormRow>
        );
    }

    return null;
};

export default DatePicker;
